import { render, staticRenderFns } from "./PadCommissionForm.vue?vue&type=template&id=0b56822e&"
import script from "./PadCommissionForm.vue?vue&type=script&lang=js&"
export * from "./PadCommissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports